import { AfterViewInit, Component, ViewChild, ElementRef, ChangeDetectorRef, Renderer2, OnDestroy, input, EventEmitter, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ChatService } from '../../services/chat.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { OpenApiService, Message, SummaryResponse, aiKeyStatusDTO, ApiKeys } from '../../../../core/services/open-api.service';
import { marked } from 'marked';
import { AuthService } from '../../../../core/services/auth.service';
import { DeepgramService } from '../../services/deepgram.service';
import { HeaderComponent } from "../../../../shared/components/layout/header/header.component";
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from '../../../../core/services/toast.service';
import { AES_SECRET_KEY } from '../../../../config';
import { importAesKey, decryptKey } from '../../../../core/utils/crypto-util';
import { OpenAiService } from '../../../../core/services/open-ai.service';


@Component({
  selector: 'app-overlay-chat-window',
  templateUrl: './overlay-chat-window.component.html',
  styleUrl: './overlay-chat-window.component.scss'
})
export class OverlayChatWindowComponent implements AfterViewInit, OnDestroy {
    receivedScreenshotData: string = '';
  showPromptIdDialog: boolean = true;
  promptIdInput: string = '';
  messagesUpdated: boolean = false;

  upperText: string = '';
  isStreaming = false;
  isNearBottom: boolean = true;
  userInput = '';
  recognition: any;
  isMicOn = false;
  isSummarizing = false;
  copiedMessage: string | null = null;
  copied = false;
  isLoadingMessages = true;
  isUploadingAttachment = false;
  attachedFileName: string = '';
  isUserScrolling = false;
  style: any;
  zoomLevel = 1;
  selectedPromptIdFromSidebar: any;
  selectedPromptId: any;
  sidebarOpened = false;
  s3FileUrl: string | { url: string } = '';
  s3FileType: 'image' | 'file' | '' = '';
  promptObj: any = null;
  interviewType: string = '';
  contextCache: any = null;
  systemPrompt: string = '';
  chatHistory: any[] = [];
  fileTypeError: string = '';
  loadedPromptData: any = null;
  loadedChatHistory: any[] = [];
  showZoomIndicator = false;
  openAiKey: string = '';
  claudeAiKey: string = '';
  // AI key status fetched on component load
  aiKeyStatuses: aiKeyStatusDTO[] = [];
  aiKeyOverallStatusText = '';
  screenshotDataUrl: string = '';

  @Input() zoomInClick = new EventEmitter<void>();
  @Input() zoomOutClick = new EventEmitter<void>();

  private abortController: AbortController | null = null;
  private transcriptBuffer = '';
  private conversationSubscription: Subscription;
  // AES helpers moved to crypto-util.ts


  @ViewChild('zoomContainer', { static: false })
  zoomContainer!: ElementRef;
  private routeSubscription: Subscription | undefined;

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;

  constructor(
    public chatService: ChatService,
    private openApiService: OpenAiService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
    private authService: AuthService,
    private deepgramService: DeepgramService,
    private route: ActivatedRoute,
    private router: Router,
    private toastService: ToastService
  ) {
    // this.authService.setIsLoggedIn(true); // Set the user as logged in
    // this.initializeSpeechRecognition();
    this.conversationSubscription = this.chatService.currentConversation$.subscribe(() => {
      // Give Angular a tick to render, then run post-render fixes
      setTimeout(() => this.scrollToBottom(), 0);
      setTimeout(() => this.addCopyButtonsToCodeBlocks(), 100);
      setTimeout(() => this.ensureImageThumbnails(), 120);
    });

    

    // Remove route param logic for selectedPromptId
    // Only use promptIdInput from popup for chat loading
  }
 

  ngAfterViewInit(): void {
    window.addEventListener('message', this._onMessage.bind(this));

    this.fetchAiApiKeys();
    this.initializeScrollListener();

    const templateId = this.getTemplateIdFromUrlOrInput();
    if (templateId) {
      this.loadChatHistory(templateId);
      this.showPromptIdDialog = false;
    }
    this.scrollToBottom();
    this.addCopyButtonsToCodeBlocks();
    this.ensureImageThumbnails();
    // Fetch AI key status when the chat window loads. Refresh stale inactive records older than 15 minutes.
    try {
      this.fetchAiKeyStatus();
    } catch (err) {
      // Non-fatal
      console.warn('fetchAiKeyStatus call failed to start', err);
    }
  }

_onMessage(event: MessageEvent) {
  const data = event.data || {};
  if (data.type === 'SCREENSHOT_CAPTURED' && data.image) {
    this.receivedScreenshotData = data.image;
    this.screenshotDataUrl = data.image;
    const preview = data.image.length > 100 ? data.image.substring(0, 100) + '...' : data.image;
    this.toastService.show(`Screenshot data received. Length: ${data.image.length}. Preview: ${preview}`, 'info');
    // Call fileSelected method to upload
    this.fileSelectedFromMessage(data.image);
  }

}

fileSelectedFromMessage(dataUrl: string) {
        if (!dataUrl || typeof dataUrl !== 'string' || !dataUrl.startsWith('data:image/')) {
          this.toastService.show('Invalid screenshot data received.', 'error');
          return;
        }
        this.toastService.show('Uploading screenshot...', 'info');
        this.isUploadingAttachment = true;
        const base64 = dataUrl.split(',')[1];
        if (!base64) {
          this.toastService.show('Failed to extract base64 from screenshot.', 'error');
          this.isUploadingAttachment = false;
          return;
        }
        this.openApiService.uploadBase64File({ base64Content: base64 }).subscribe({
          next: (url: string) => {
            this.s3FileUrl = url;
            this.s3FileType = 'image';
            this.attachedFileName = 'screenshot.png';
            this.isUploadingAttachment = false;
            this.toastService.show('Screenshot uploaded successfully!', 'success');
          },
          error: (err) => {
            this.s3FileUrl = '';
            this.s3FileType = '';
            this.attachedFileName = '';
            this.isUploadingAttachment = false;
            this.toastService.show('Screenshot upload failed!', 'error');
          }
        });
      }


  /**
   * Ensure any <img> elements rendered into message bodies have the
   * expected thumbnail attributes and class. We avoid using bypassSecurityTrustHtml
   * and instead let Angular sanitize the HTML, then post-process the DOM to
   * add attributes (class, inline sizing, loading/decoding) so images preview
   * correctly while keeping content safe.
   */
  ensureImageThumbnails(): void {
    try {
      if (!this.scrollContainer || !this.scrollContainer.nativeElement) return;
      const imgs: NodeListOf<HTMLImageElement> = this.scrollContainer.nativeElement.querySelectorAll('.message-body img');
      imgs.forEach((img: HTMLImageElement) => {
        // Add class if missing
        if (!img.classList.contains('chat-thumbnail')) {
          this.renderer.addClass(img, 'chat-thumbnail');
        }
        // Attributes for performance and consistent sizing
        this.renderer.setAttribute(img, 'loading', 'lazy');
        this.renderer.setAttribute(img, 'decoding', 'async');
        this.renderer.setAttribute(img, 'draggable', 'false');
        // Inline style to prevent intrinsic-size expansion overriding CSS
        const style = 'width:150px;max-width:150px;max-height:320px;height:auto;object-fit:cover;border-radius:8px;display:inline-block;';
        this.renderer.setAttribute(img, 'style', style);
      });
    } catch (err) {
      // Non-fatal; logs for debugging
      console.warn('ensureImageThumbnails failed', err);
    }
  }
  isLoadingPromptChat: boolean = false;

  async onPromptIdSubmit() {
    if (this.promptIdInput && this.promptIdInput.trim()) {
      this.selectedPromptId = this.promptIdInput.trim();
      this.isLoadingPromptChat = true;
      try {
        await this.loadChatHistory(this.selectedPromptId);
        if (!this.loadedChatHistory || this.loadedChatHistory.length === 0) {
          this.toastService.show('Invalid Prompt ID. Please check and try again.', 'error');
        } else {
          this.showPromptIdDialog = false;
        }
      } catch (err) {
        this.toastService.show('Error loading prompt. Please try again.', 'error');
      } finally {
        this.isLoadingPromptChat = false;
      }
    }
  }

  onPromptIdInputKeydown(event: KeyboardEvent) {
    if (event && event.key === 'Enter' && this.promptIdInput.trim()) {
      event.preventDefault();
      this.onPromptIdSubmit();
    }
  }

  onPromptIdRefresh(): void {
    this.promptIdInput = '';
    this.selectedPromptId = '';
    this.loadedChatHistory = [];
    this.showPromptIdDialog = true;
    this.toastService.show('Prompt ID input refreshed.', 'info');
    window.location.reload();
  }

  ngOnDestroy() {
    this.conversationSubscription.unsubscribe();
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  // Fetch AI key status from backend and cache locally. First refresh stale inactive records (>=15 minutes).
  async fetchAiKeyStatus(): Promise<void> {
    try {
      const res = await this.openApiService.refreshAndGetAiKeyStatus(5);
      this.aiKeyStatuses = res || [];
      this.aiKeyOverallStatusText = this.getAiKeyOverallStatusText();
      this.cdr.detectChanges();
    } catch (err) {
      console.error('Failed to fetch AI key status', err);
    }
  }

  isAiKeyHealthy(): boolean {
    if (!this.aiKeyStatuses || this.aiKeyStatuses.length === 0) return true;
    // treat any non-OK or any error text as unhealthy
    return !this.aiKeyStatuses.some(s => (s.status && String(s.status).toLowerCase() !== 'ok') || (s.error && String(s.error).trim() !== ''));
  }

  getAiKeyOverallStatusText(): string {
    if (!this.aiKeyStatuses || this.aiKeyStatuses.length === 0) return 'AI keys: unknown';
    if (this.isAiKeyHealthy()) return 'AI keys: OK';
    const issues = this.aiKeyStatuses.filter(s => (s.status && String(s.status).toLowerCase() !== 'ok') || (s.error && String(s.error).trim() !== '')).length;
    return `AI key issues: ${issues}`;
  }

  onPromptSelected(promptId: any): void {
    this.selectedPromptId = promptId;
    console.log('Prompt ID in parent:', this.selectedPromptId);
    if (this.selectedPromptId) {
      this.loadChatHistory(this.selectedPromptId);
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { templateId: this.selectedPromptId },
      queryParamsHandling: 'merge', // merge to keep other params
    });
  }
  private initializeScrollListener(): void {
    this.chatService.selectConversation({
      id: '',
      title: '',
      messages: [],
      chatThreadId: '',
    });
    this.scrollContainer.nativeElement.addEventListener('scroll', this.onScroll.bind(this));
  }

  private getTemplateIdFromUrlOrInput(): string {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      return params.get('templateId') || this.selectedPromptId || '';
    }
    return this.selectedPromptId || '';
  }


  private async loadChatHistory(templateId: string): Promise<void> {
    this.isLoadingMessages = true;
    try {
      // Load prompt data and chat history in parallel
      const [history] = await Promise.all([
        // this.openApiService.getPromptById(templateId).toPromise(),
        this.openApiService.getChatHistoryByPromptId(templateId).toPromise()
      ]);

      // Store the loaded data 
      // this.loadedPromptData = promptData;
      this.loadedChatHistory = history || [];

      if (history && history.length > 0) {
        const reversedHistory = [...history].reverse();
        const messages = reversedHistory.flatMap((h) => {
          const msgs: Message[] = [
            { text: h.question, sender: 'user', timestamp: new Date(h.timestamp) },
          ];
          if (h.answer) {
            msgs.push({ text: h.answer, sender: 'bot', timestamp: new Date(h.timestamp) });
          }
          if (h.s3Url && h.s3Url.match(/\.(jpg|jpeg|png|gif|bmp|webp)$/i)) {
            msgs[0].text = `${h.question}<br><a href='${h.s3Url}' target='_blank' rel='noopener noreferrer'><img class='chat-thumbnail' src='${h.s3Url}' alt='attachment' loading='lazy' decoding='async' draggable='false' style="width:150px;max-width:150px;max-height:320px;height:auto;object-fit:cover;border-radius:8px;display:inline-block;"/></a>`;
          }
          return msgs;
        });

        const conversation = {
          id: reversedHistory[0].chatThreadId || templateId,
          title: reversedHistory[0].question?.substring(0, 25) + '...' || 'Chat',
          messages: messages,
          chatThreadId: reversedHistory[0].chatThreadId || templateId,
        };

        this.chatService.selectConversation(conversation);
      }
    } catch (error) {
      console.error('Error loading chat history:', error);
      this.toastService.show('Error loading chat history', 'error');
    } finally {
      this.isLoadingMessages = false;
      this.scrollToBottom();
    }
  }
  get currentConversation$() {
    return this.chatService.currentConversation$;
  }

  sendMessageOnEnter(event: KeyboardEvent): void {
    // First, prevent default behavior for Enter without shift
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();

      // If streaming is active, completely prevent any action
      if (this.isStreaming) {
        event.stopPropagation(); // Stop event from bubbling up
        return;
      }

      // Only send a new message if we have input and no active streaming
      const trimmedInput = this.userInput.trim();
      if (trimmedInput && !this.isStreaming) {
        this.sendMessage();
      }
    }
  }

  toggleSidebar() {
    this.sidebarOpened = !this.sidebarOpened;
  }
  onScroll(): void {
    const el = this.scrollContainer.nativeElement;
    this.isUserScrolling = el.scrollTop + el.clientHeight < el.scrollHeight;
    this.isNearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 50; // or your threshold
  }


  async sendMessage() {
    // Prevent sending new messages while streaming
    if (this.isStreaming) {
      return;
    }

    this.currentConversation$.pipe(take(1)).subscribe(async currentConv => {
      const combinedText = (this.upperText + ' ' + this.userInput).trim();
      if (!combinedText || !currentConv) return;

      if (this.s3FileUrl) {
        this.sendMessageWithAttachment(currentConv);
        return;
      }

      const promptId = this.selectedPromptId || '';
      // Fix: If promptId is set from popup, ensure loadedPromptData is set
      if (!promptId) {
        this.toastService.show('Error: Please enter a prompt ID.', 'error');
        return;
      }
      // If loadedPromptData is missing, try to fetch it before showing error
      if (!this.loadedPromptData) {
        try {
          // Attempt to fetch prompt data (if needed, you can adjust this to your API)
          // Example: this.loadedPromptData = await this.openApiService.getPromptById(promptId).toPromise();
          // For now, just set a default object to avoid error
          this.loadedPromptData = { interviewType: '' };
        } catch (err) {
          this.toastService.show('Error: Template not loaded properly', 'error');
          return;
        }
      }

      // Use the preloaded prompt data
      const interviewType = this.loadedPromptData.interviewType || '';

      let model = 'gpt-4o';
      if (interviewType === 'practice') {
        model = 'gpt-4.1-mini';
      } else if (interviewType === 'screening' || interviewType === 'firstround') {
        model = 'gpt-5.2';
      } else if (interviewType === 'finalround') {
        model = 'claude-sonnet-4-5-20250929';
      }

      const userMessageText = combinedText;
      this.userInput = '';
      this.upperText = '';
      this.transcriptBuffer = '';

      if (currentConv.messages.length === 0) {
        this.chatService.updateConversationTitle(userMessageText.substring(0, 25) + '...');
      }

      const userMsg: Message = { text: userMessageText, sender: 'user', timestamp: new Date() };
      this.chatService.addMessage(userMsg);

      // Show an immediate initial response
      const initialResponse = "";
      const botPlaceholderMsg: Message = { text: initialResponse, sender: 'bot', timestamp: new Date() };
      this.chatService.addMessage(botPlaceholderMsg);

      // Scroll immediately after adding messages
      setTimeout(() => this.scrollToBottom(), 0);

      // Get accurate bot placeholder index
      const messages = (await this.chatService.currentConversation$.pipe(take(1)).toPromise())?.messages || [];
      const botMessageIndex = messages.length - 1;

      // Use preloaded data to build context (service will fetch history by promptId)
      const context = await this.openApiService.buildContextFromPreloadedData(
        this.loadedPromptData,
        userMessageText,
        promptId
      );

      const chatId = promptId;

      // Set up streaming with immediate feedback
      this.isStreaming = true;
      this.abortController = new AbortController();
      let fullAnswer = '';

      // Start showing thinking indicators immediately
      let thinkingDots = '';
      const thinkingInterval = setInterval(() => {
        if (this.isStreaming && !fullAnswer) {
          thinkingDots = thinkingDots.length >= 3 ? '' : thinkingDots + '.';
          this.chatService.updateBotMessage(botMessageIndex, '' + '');
        } else {
          clearInterval(thinkingInterval);
        }
      }, 300);
      let firstChunk = true; // Declare firstChunk variable
      try {
        console.log('Selected model:', model);
        if (model === 'claude-sonnet-4-5-20250929') {
          await this.openApiService.streamClaudeAnswerWithContext(
            context,
            botMessageIndex,
            {
              updateBotMessage: (idx: number, text: string) => {
                this.chatService.updateBotMessage(idx, text);
                setTimeout(() => this.scrollToBottomWithPadding(10), 10);

              },
              finalizeConversation: () => this.chatService.finalizeConversation()
            },
            (partial: string) => {
              fullAnswer = partial;
            },
            this.abortController.signal,
            model,
            interviewType
          );
        } else {
          await this.openApiService.streamAskQuestionWithContext(
            context,
            botMessageIndex,
            {
              updateBotMessage: (idx: number, text: string) => {
                if (firstChunk && text.length > 0) {
                  firstChunk = false;
                  text = text.replace(/^\.{3}/, '');
                }
                this.chatService.updateBotMessage(idx, text);
                setTimeout(() => this.scrollToBottomWithPadding(10), 10);

              },
              finalizeConversation: () => this.chatService.finalizeConversation()
            },
            (partial: string) => {
              fullAnswer = partial;
            },
            this.abortController.signal,
            model,
            interviewType
          );
        }
      } catch (e) {
        this.chatService.finalizeConversation();
      } finally {
        this.isStreaming = false;
        this.abortController = null;
      }
      await this.openApiService.saveAnswer(promptId, userMessageText, fullAnswer);
    });

    this.isNearBottom = true;
    this.isUserScrolling = false;
    this.messagesUpdated = true;
  }





  scrollToStopAtLastQuestion() {
    const container = this.scrollContainer.nativeElement;
    // Get all message wrapper elements
    const messageElements = container.querySelectorAll('.message-wrapper');
    if (messageElements.length === 0) {
      // fallback to scroll bottom if no messages
      container.scrollTop = container.scrollHeight;
      return;
    }

    // Find the last user message (assuming sender 'user')
    let lastUserMsg: HTMLElement | null = null;
    for (let i = messageElements.length - 1; i >= 0; i--) {
      const msgElem = messageElements[i] as HTMLElement;
      // You need to identify user messages, e.g., with a class 'user'
      if (msgElem.classList.contains('user')) {
        lastUserMsg = msgElem;
        break;
      }
    }

    if (!lastUserMsg) {
      // If no user message found, scroll to bottom
      container.scrollTop = container.scrollHeight;
      return;
    }

    const containerRect = container.getBoundingClientRect();
    const lastUserMsgRect = lastUserMsg.getBoundingClientRect();

    // Calculate where to scroll so the last user message bottom is just above the viewport
    const targetScrollTop = container.scrollTop + (lastUserMsgRect.bottom - containerRect.top) - 10; // 10px margin

    // Scroll to that position
    container.scrollTop = targetScrollTop;
  }



  ngAfterViewChecked() {
    if (this.messagesUpdated) {
      this.scrollToBottom(true);
      // this.scrollToBottomWithPadding()
      this.messagesUpdated = false;
    }
  }

  // trackBy function for *ngFor to preserve DOM nodes when messages update
  trackByMessage(index: number, msg: any): any {
    if (!msg) return index;
    if (msg.id !== undefined && msg.id !== null) return msg.id;
    if (msg.timestamp) return typeof msg.timestamp === 'number' ? msg.timestamp : new Date(msg.timestamp).getTime();
    return index;
  }

  scrollToBottomWithPadding(padding = 10) {
    const container = this.scrollContainer.nativeElement;
    if (!this.isUserScrolling) { // respects manual user scroll
      container.scrollTop = container.scrollHeight - container.clientHeight - padding;
    }
  }



  moveInputToUpper() {
    if (this.userInput.trim()) {
      this.upperText = this.upperText ? (this.upperText + ' ' + this.userInput.trim()) : this.userInput.trim();
    }
    this.userInput = '';
    this.transcriptBuffer = '';
  }

  stopStreaming() {
    if (this.isStreaming && this.abortController) {
      // Stop the current stream
      this.abortController.abort();
      this.isStreaming = false;

      // Get current conversation to get the last bot message
      this.currentConversation$.pipe(take(1)).subscribe(async currentConv => {
        if (!currentConv || !currentConv.messages.length) return;

        // Get the last bot message (it should be the one we're currently streaming)
        const messages = currentConv.messages;
        const lastBotMessageIndex = messages.length - 1;
        const lastMessage = messages[lastBotMessageIndex];

        if (lastMessage && lastMessage.sender === 'bot') {
          // Add a note that the response was stopped
          const currentText = lastMessage.text;
          const stoppedText = currentText;
          this.chatService.updateBotMessage(lastBotMessageIndex, stoppedText);

          // Save the partial response
          // const promptId = this.selectedPromptId || '';
          // if (promptId) {
          //   // Get the user's message (second to last message)
          //   const userMessage = messages[lastBotMessageIndex - 1]?.text || '';
          //   // Save whatever response we got before stopping
          //   this.openApiService.saveAnswer(promptId, userMessage, stoppedText)
          //     .catch(console.error); // Handle save errors silently
          // }
        }

        // Cleanup
        this.chatService.finalizeConversation();
      });
    }
  }
  onZoomIn() {
    let newPercentage = this.zoomLevel * 100 + 10;
    this.setZoomPercentage(newPercentage);
  }

  onZoomOut() {
    let newPercentage = this.zoomLevel * 100 - 10;
    this.setZoomPercentage(newPercentage);
  }

  get zoomDisplayValue(): string {
    return Math.round(this.zoomLevel * 100) + '%';
  }

  setZoom(change: number) {
    this.zoomLevel = Math.min(Math.max(this.zoomLevel + change, 0.5), 2);
    if (this.zoomContainer && this.zoomContainer.nativeElement) {
      const baseFontSize = 14; // base font size in px
      const newFontSize = baseFontSize * this.zoomLevel;
      this.zoomContainer.nativeElement.style.fontSize = `${newFontSize}px`;
      this.zoomContainer.nativeElement.style.lineHeight = (newFontSize * 1.4) + 'px';
    }

  }

  setZoomPercentage(percentage: number) {
    this.zoomLevel = Math.min(Math.max(percentage / 100, 0.5), 2);
    const baseFontSize = 14;
    const newFontSize = baseFontSize * this.zoomLevel;
    if (this.zoomContainer?.nativeElement) {
      this.zoomContainer.nativeElement.style.fontSize = `${newFontSize}px`;
      this.zoomContainer.nativeElement.style.lineHeight = `${newFontSize * 1.4}px`;
    }
    this.showZoomIndicator = true;
    // Hide after 2 seconds automatically (optional)
    setTimeout(() => this.showZoomIndicator = false, 10000);
  }

  toggleZoomIndicator() {
    this.showZoomIndicator = !this.showZoomIndicator;
  }

  resetZoom() {
    console.log("zoom clicked")
    this.zoomLevel = 1; // reset zoom to 100%
    const baseFontSize = 14;
    if (this.zoomContainer?.nativeElement) {
      this.zoomContainer.nativeElement.style.fontSize = `${baseFontSize}px`;
      this.zoomContainer.nativeElement.style.lineHeight = `${baseFontSize * 1.4}px`;
    }
    this.showZoomIndicator = true;
    setTimeout(() => this.showZoomIndicator = false, 100);
    this.cdr.detectChanges(); // ensure UI updates if needed
  }

  sendMessageWithAttachment(currentConv: any) {
    let promptId = this.selectedPromptId || '';
    if (!promptId && typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      promptId = urlParams.get('templateId') || '';
    }
    if (!promptId) {
      this.toastService.show('Error: Please enter a prompt ID before sending.', 'error');
      return;
    }

    const userMessageText = (this.upperText + ' ' + this.userInput).trim();
    this.userInput = '';
    this.upperText = '';
    this.transcriptBuffer = '';
    let s3Url: string = '';

    if (typeof this.s3FileUrl === 'object' && this.s3FileUrl !== null) {
      s3Url = this.s3FileUrl.url || '';
    } else {
      s3Url = this.s3FileUrl as string;
    }
    if (currentConv.messages.length === 0) {
      this.chatService.updateConversationTitle(userMessageText.substring(0, 25) + '...');
    }

    let userMsgText = userMessageText;
    if (s3Url) {
      if (this.s3FileType === 'image') {
        // insert a small thumbnail wrapped in a link and force sizing with inline style
        userMsgText += `<br><a href='${s3Url}' target='_blank' rel='noopener noreferrer'><img class='chat-thumbnail' src='${s3Url}' alt='attachment' loading='lazy' decoding='async' draggable='false' style="width:150px;max-width:150px;max-height:320px;height:auto;object-fit:cover;border-radius:8px;display:inline-block;"/></a>`;
      } else {
        userMsgText += `<br><a href='${s3Url}' target='_blank' rel='noopener noreferrer'>View file</a>`;
      }
    }
    const userMsg: Message = { text: userMsgText, sender: 'user', timestamp: new Date() };
    this.chatService.addMessage(userMsg);

    const botPlaceholderMsg: Message = { text: '...', sender: 'bot', timestamp: new Date() };
    this.chatService.addMessage(botPlaceholderMsg);
    const botMessageIndex = currentConv.messages.length - 1;

    const chatId = promptId;

    let apiCall;
    if (this.s3FileType === 'image') {
      apiCall = this.openApiService.sendTextAndImageToOpenAI(userMessageText, s3Url);
    } else {
      apiCall = this.openApiService.sendTextAndFileToOpenAI(userMessageText, s3Url);
    }
    let fullAnswer = '';
    apiCall.subscribe({
      next: (response: any) => {
        const outputText = this.openApiService.extractOpenAIText(response);
        fullAnswer = outputText || 'No response';
        this.chatService.updateBotMessage(botMessageIndex, fullAnswer);
        // Send streamed chunk to backend relay
        // setTimeout(() => this.scrollToBottomWithPadding(20), 0);

      },
      error: (err) => {
        this.openApiService.saveAnswer(promptId, userMessageText, err, s3Url);
        this.chatService.updateBotMessage(botMessageIndex, 'Sorry, something went wrong processing your request.');
        this.chatService.finalizeConversation();
        this.s3FileUrl = '';
        this.s3FileType = '';
      },
      complete: () => {
        this.chatService.finalizeConversation();
        this.openApiService.saveAnswer(promptId, userMessageText, fullAnswer, s3Url);
        this.s3FileUrl = '';
        this.s3FileType = '';
      }
    });
  }

  async typeBotMessage(fullText: string, messageIndex: number) {
    const parts = fullText.split(/(```[\s\S]*?```)/);
    let currentText = '';

    for (const part of parts) {
      currentText += part;
      this.chatService.updateBotMessage(messageIndex, currentText);
      if (!part.startsWith('```')) {
        await new Promise(res => setTimeout(res, 20)); // Type regular text quickly
      } else {
        await new Promise(res => setTimeout(res, 50)); // Pause slightly for code blocks
      }
    }
    this.chatService.finalizeConversation();
    this.cdr.detectChanges();
    this.addCopyButtonsToCodeBlocks();
  }

  toggleMic() {
    // Toggle intent
    const turningOn = !this.isMicOn;
    if (turningOn) {
      // Try to start listening and only set isMicOn=true if successful
      this.transcriptBuffer = this.userInput;
      this.deepgramService.startListening((transcript: string, isFinal: boolean) => {
        if (isFinal) {
          this.transcriptBuffer += (this.transcriptBuffer ? ' ' : '') + transcript;
          this.userInput = this.transcriptBuffer;
        } else {
          this.userInput = this.transcriptBuffer + (this.transcriptBuffer ? ' ' : '') + transcript;
        }
        this.cdr.detectChanges();
      }).then(() => {
        this.isMicOn = true;
        this.cdr.detectChanges();
      }).catch((err) => {
        console.error('Failed to start microphone:', err);
        this.isMicOn = false;
        this.cdr.detectChanges();
      });
    } else {
      // Turn off immediately in UI and stop backend listening
      this.isMicOn = false;
      this.stopRecording();
      this.deepgramService.stopListening();
      this.userInput = this.transcriptBuffer;
      this.cdr.detectChanges();
    }
  }

  stopRecording() {
    this.isMicOn = false;
    this.deepgramService.stopListening();
    this.userInput = this.transcriptBuffer;
  }



  // Return a plain string; Angular will sanitize it automatically when used with [innerHTML].
  formatMessage(text: string): string {
    const parsed = marked.parse(text);
    return parsed as string;
  }

  copyCodeBlock(index: number) {
    this.currentConversation$.pipe(take(1)).subscribe(currentConv => {
      if (!currentConv || !currentConv.messages[index]) return;
      const msg = currentConv.messages[index];
      // Extract code block from message text
      const codeMatch = msg.text.match(/```([\s\S]*?)```/);
      if (codeMatch && codeMatch[1]) {
        const code = codeMatch[1].trim();
        navigator.clipboard.writeText(code);
      }
    });
  }

  addCopyButtonsToCodeBlocks() {
    if (!this.scrollContainer?.nativeElement) return;
    const preElements = this.scrollContainer.nativeElement.querySelectorAll('pre');
    preElements.forEach((pre: HTMLElement, idx: number) => {
      if (pre.querySelector('.copy-btn')) return;
      // ensure pre is positioned relatively so absolute button positions correctly
      if (!pre.style.position) {
        pre.style.position = pre.style.position || 'relative';
      }

      // create a real button element for accessibility
      const button = this.renderer.createElement('icon');
      this.renderer.addClass(button, 'copy-btn');
      this.renderer.setAttribute(button, 'type', 'button');
      this.renderer.setAttribute(button, 'aria-label', 'Copy code');
      // initial icon (copy)
      button.innerHTML = '<mat-icon class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color">content_copy</mat-icon>';

      // click handler with visual feedback
      const onClick = async (ev: Event) => {
        ev.stopPropagation();
        const code = pre.querySelector('code')?.innerText || pre.innerText || '';
        try {
          await navigator.clipboard.writeText(code);
          // show tick icon + copied class
          button.innerHTML = '<mat-icon class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color">check_circle</mat-icon>';
          this.renderer.addClass(button, 'copied');
          // optional small animation: scale then revert
          setTimeout(() => {
            // revert to copy icon
            button.innerHTML = '<mat-icon class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color">content_copy</mat-icon>';
            this.renderer.removeClass(button, 'copied');
          }, 1500);
        } catch (err) {
          // fallback: do nothing but remove any copied state
          this.renderer.removeClass(button, 'copied');
        }
      };

      // Use renderer.listen so Angular cleans up if element removed
      this.renderer.listen(button, 'click', (ev: Event) => { onClick(ev as Event).catch(() => { }); });
      this.renderer.appendChild(pre, button);
    });
  }

  // scrollToBottom(): void {
  //   try {
  //     // Only scroll to the bottom if the user is not currently scrolling
  //     if (!this.isUserScrolling) {
  //       this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
  //     }
  //   } catch (err) {
  //     console.error('Error while scrolling:', err);
  //   }
  // }


  // This method should be called when user stops scrolling (e.g., by using a timeout or debounce)


  summarizeConversation() {
    this.currentConversation$.pipe(take(1)).subscribe(currentConv => {
      if (!currentConv || currentConv.messages.length < 2 || this.isSummarizing) return;
      this.isSummarizing = true;
      this.openApiService.getSummary(currentConv.messages).subscribe({
        next: (response: SummaryResponse) => {
          if (response && response.title && response.summary) {
            const htmlContent = `<h1>${response.title}</h1>${marked.parse(response.summary) as string}`;
            const cleanFileName = response.title.toLowerCase().replace(/[\s\W-]+/g, '_').replace(/_+/g, '_').replace(/^_+|_+$/g, '');
            this.downloadContentAsDoc(htmlContent, `${cleanFileName || 'chat_summary'}.doc`);
          }
          this.isSummarizing = false;
        },
        error: () => {
          alert('Failed to generate summary.');
          this.isSummarizing = false;
        }
      });
    });
  }

  downloadDoc(msg: Message) {
    if (!msg || !msg.text) return;
    const htmlContent = marked.parse(msg.text) as string;
    this.downloadContentAsDoc(htmlContent, 'AIResponse.doc');
  }

  private downloadContentAsDoc(htmlContent: string, fileName: string) {
    const header = `<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export</title></head><body>`;
    const footer = "</body></html>";
    const sourceHTML = header + htmlContent + footer;
    const blob = new Blob(['\ufeff', sourceHTML], { type: 'application/msword' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  onInputKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
    // If Shift+Enter, let it add a new line (default behavior)
  }





  async onFileSelected(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const isImage = file.type.startsWith('image/');
      const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
      if (!isImage && !isPdf) {
        this.fileTypeError = 'Only image and PDF files are supported.';
        return;
      }
      this.fileTypeError = '';
      this.isUploadingAttachment = true;
      if (isImage) {
        // Convert image to base64
        const base64 = await this.convertToBase64(file);
        // Upload base64 to backend and get S3 URL
        this.openApiService.uploadBase64File({ base64Content: base64 }).subscribe({
          next: (url: string) => {
            this.s3FileUrl = url;
            this.s3FileType = 'image';
            this.attachedFileName = file.name;
            this.isUploadingAttachment = false;
          },
          error: (err) => {
            this.s3FileUrl = '';
            this.s3FileType = '';
            this.attachedFileName = '';
            this.isUploadingAttachment = false;
            if (this.fileInput) this.fileInput.nativeElement.value = '';
          }
        });
      } else if (isPdf) {
        // Read PDF as text
        const textContent = await this.readFileAsText(file);
        // Upload text to backend and get S3 URL
        this.openApiService.uploadTextFile({ textContent, fileName: file.name }).subscribe({
          next: (url: string) => {
            this.s3FileUrl = url;
            this.s3FileType = 'file';
            this.attachedFileName = file.name;
            this.isUploadingAttachment = false;
          },
          error: (err) => {
            this.s3FileUrl = '';
            this.s3FileType = '';
            this.attachedFileName = '';
            this.isUploadingAttachment = false;
            if (this.fileInput) this.fileInput.nativeElement.value = '';
          }
        });
      }
    }
  }

  async convertToBase64(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        const base64 = result.split(',')[1] || result;
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  async readFileAsText(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsText(file);
    });
  }


  // copyToClipboard(text: string): void {
  //   navigator.clipboard.writeText(text).then(() => {
  //     this.copiedMessage = text;
  //     setTimeout(() => this.copiedMessage = null, 1500);
  //   });
  // } 

  copyToClipboard(msg: Message): void {
    navigator.clipboard.writeText(msg.text).then(() => {
      msg.copied = true;

      setTimeout(() => {
        msg.copied = false;
      }, 2000); // Reset after 2 seconds
    });
  }

  scrollToBottom(force: boolean = false): void {
    try {
      if (!this.isUserScrolling || force) {
        this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
        this.isNearBottom = true;
      }
    } catch (err) {
      console.error('Scroll error:', err);
    }
  }


  // This method is triggered when the user starts scrolling
  onUserScroll(): void {
    const scrollTop = this.scrollContainer.nativeElement.scrollTop;
    const scrollHeight = this.scrollContainer.nativeElement.scrollHeight;
    const clientHeight = this.scrollContainer.nativeElement.clientHeight;

    // User is scrolling manually, we set the flag to true
    this.isUserScrolling = true;

    // Check if the user is near the bottom (e.g., within 50px of the bottom)
    this.isNearBottom = (scrollHeight - scrollTop - clientHeight) < 50;
  }

  // This method is triggered when the user stops scrolling
  onUserStopScroll(): void {
    setTimeout(() => {
      if (!this.isStreaming && this.isNearBottom) {
        this.isUserScrolling = false;
        this.scrollToBottom(true);
      }
    }, 1000); // shorter, more responsive
  }



fetchAiApiKeys(): void { 
  this.openApiService.getApiKeys().subscribe({
    next: async (keys: { openAiKey: string; claudeAiKey: string }) => {
      try {
        const aesKeyBase64 = AES_SECRET_KEY;
        const { cryptoKey, fallbackKeyBytes } = await importAesKey(aesKeyBase64);
        try {
          console.debug('AES import result', {
            aesKeyBase64Length: aesKeyBase64?.length || 0,
            cryptoKeyIsNull: cryptoKey === null,
            fallbackKeyBytesLen: fallbackKeyBytes ? fallbackKeyBytes.length : 0
          });
        } catch (dbgErr) {
          console.debug('AES import debug failed', dbgErr);
        }
        this.openAiKey = await decryptKey(keys.openAiKey, cryptoKey, fallbackKeyBytes);
        this.claudeAiKey = await decryptKey(keys.claudeAiKey, cryptoKey, fallbackKeyBytes);
        this.openApiService.setKeys(this.openAiKey, this.claudeAiKey);
      } catch (e) {
        console.error('Error decrypting keys', e);
      }
    },
    error: (err) => {
      console.error('Failed to load API keys', err);
    }
  });
} 


}
